import { Input } from '../atoms/Input';

interface PhoneInputProps {
  countryCode: string;
  phoneNumber: string;
  onPhoneNumberChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

export const PhoneInput = ({
  countryCode,
  phoneNumber,
  onPhoneNumberChange,
  disabled = false,
  className,
}: PhoneInputProps) => {
  const handleChange = (value: string) => {
    // Solo permitir números y máximo 10 dígitos
    const numericValue = value.replace(/\D/g, '');
    const limitedValue = numericValue.slice(0, 10);
    onPhoneNumberChange(limitedValue);
  };

  return (
    <Input
      type="tel"
      value={phoneNumber}
      onChange={handleChange}
      prefix={countryCode}
      placeholder="9316983060"
      disabled={disabled}
      className={className}
    />
  );
};
